import { Type83fEnum } from '@crm/api/types.gen'
import { Text } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Checkbox, Col, Form, Input, InputNumber } from 'antd'
import { FormInstance } from 'antd/lib'

import { useStyles } from './styles'

type Props = {
  form: FormInstance
  disabled?: boolean
}

export const CustomFieldsValidationRules = ({ form, disabled }: Props) => {
  const { t } = useLocales()
  const { styles } = useStyles()

  const type = Form.useWatch('type', form)

  return (
    <>
      <Col span={24} className={styles.validationTitle}>
        <Text size={16} weight={500}>
          {t('nomenclature.validation_rules')}
        </Text>
      </Col>
      {type === Type83fEnum.TEXT && (
        <Col span={24}>
          <Form.Item
            name={['validation_rules', 'pattern']}
            label={t('nomenclature.pattern')}
          >
            <Input
              disabled={disabled}
              placeholder={t('nomenclature.pattern')}
            />
          </Form.Item>
        </Col>
      )}

      {type === Type83fEnum.NUMBER && (
        <>
          <Col span={12}>
            <Form.Item
              name={['validation_rules', 'min']}
              label={t('nomenclature.min')}
            >
              <InputNumber
                placeholder={t('nomenclature.min')}
                className="w-full"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name={['validation_rules', 'max']}
              label={t('nomenclature.max')}
            >
              <InputNumber
                placeholder={t('nomenclature.max')}
                className="w-full"
              />
            </Form.Item>
          </Col>
        </>
      )}
      <Col span={12}>
        <Form.Item name="is_required" valuePropName="checked">
          <Checkbox>{t('nomenclature.required')}</Checkbox>
        </Form.Item>
      </Col>
    </>
  )
}
